package pwgs.ui.scenes.playerscene


class PlayerSceneControllerFe(props: PlayerSceneProps, scene: MPlayerSceneScene) : APlayerSceneControllerFe(props, scene) {

    override fun createInitialModel() : PlayerSceneModel {
        return PlayerSceneModel("", false, "")
    }

    override fun init() {
        call_load()
    }

    fun onBanButtonClick() {
        model.error = null
        model.isLoading = true
        render()

        call_ban()
    }

    fun onUnbanButtonClick() {
        model.error = null
        model.isLoading = true
        render()

        call_unban()
    }


}

